import { faCog, faTrash } from '@fortawesome/pro-light-svg-icons';
import {
    faCog as solidFaCog,
    faTrash as solidFaTrash,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionMenu } from 'components/menu/ActionMenu';
import { ActionMenuButton } from 'components/menu/ActionMenuButton';
import { ActionMenuItem } from 'components/menu/ActionMenuItem';
import { ActionMenuTableCell } from 'components/menu/ActionMenuTableCell';
import { usePopup } from 'custom_hooks/usePopup';
import { useThemeValues } from 'styles/theme';

export type SettingsDeleteActionMenuProps = {
    className?: string;
    onSettingsClick: () => void;
    onDeleteClick: () => void;
    canEdit?: boolean;
    canDelete?: boolean;
    renderContext?: 'table' | undefined;
};
export function SettingsDeleteActionMenu({
    className,
    onSettingsClick,
    onDeleteClick,
    canEdit,
    canDelete,
    renderContext,
}: SettingsDeleteActionMenuProps) {
    const { isOpen, toggleOpen, close, triggerRef, popupRef } = usePopup();
    const { link, secondaryText, deleteButton } = useThemeValues();
    return (
        <ActionMenuTableCell className={className}>
            {canEdit && (
                <ActionMenuButton
                    onClick={toggleOpen}
                    ref={triggerRef}
                    // the table button wrappers will handle the 'active' border
                    // styling
                    borderless={renderContext === 'table'}
                />
            )}
            {isOpen && (
                <ActionMenu
                    onClose={close}
                    ref={popupRef}
                    buttonRef={triggerRef}
                    useOverlay
                >
                    <ActionMenuItem
                        title="Settings"
                        hoverIcon={<FontAwesomeIcon icon={solidFaCog} color={link} />}
                        icon={<FontAwesomeIcon icon={faCog} color={secondaryText} />}
                        onSelect={() => {
                            close();
                            onSettingsClick();
                        }}
                    />
                    {canDelete && (
                        <ActionMenuItem
                            title="Delete"
                            hoverIcon={
                                <FontAwesomeIcon
                                    icon={solidFaTrash}
                                    color={deleteButton}
                                />
                            }
                            icon={
                                <FontAwesomeIcon icon={faTrash} color={secondaryText} />
                            }
                            onSelect={() => {
                                close();
                                onDeleteClick();
                            }}
                        />
                    )}
                </ActionMenu>
            )}
        </ActionMenuTableCell>
    );
}
